import React from "react";
import StringUtils from "../../../utils/StringUtils";
import useTranslationJobs from "../useTranslationJobs";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import "./NewApplicationByJobCount.scss";
import useQueryApplicationSearchCount from "./useQueryApplicationSearchCount";

function NewApplicationByJobCount(props) {
  const { jobId } = props;
  const { t, loading: tLoading } = useTranslationJobs();
  useShowLoader(tLoading, "NewApplicationsByJobCount");

  const {
    data: count,
    loading,
    errors,
  } = useQueryApplicationSearchCount(jobId, { viewed: false });

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() =>
          count > 0 && (
            <span className="NewApplicationByJobCount">
              {t("jobs:employers_job_details_new_candidate_count", {
                count: StringUtils.nullToZero(count),
              })}
            </span>
          )
        }
      />
    </HorizontalLoader>
  );
}

export default NewApplicationByJobCount;
